
type Writable<T> = { -readonly [P in keyof T]: T[P] };

export interface BaseElementOptions {
    container?: HTMLElement;
}

export abstract class BaseElement<ElementType extends HTMLElement = HTMLDivElement> {

    public readonly element: ElementType;

    public readonly onResize: e5.ResizeSignal;

    protected readonly _mutable: {
        -readonly [k in keyof this]: this[k];
    } = this;

    private _containerToAdd: HTMLElement = null;

    constructor() {
        this.onResize = e5.Resize.create();
        this.onResize.add(() => this.resize());
    }

    public create(options: BaseElementOptions): this {
        if (options.container) {
            if (this.element) {
                options.container.appendChild(this.element);
            } else {
                this._containerToAdd = options.container;
            }
        }
        return this;
    }

    protected setElement(element: ElementType): void {
        this._mutable.element = element;
        this.onResize.element = element;
        if (this._containerToAdd) {
            this._containerToAdd.appendChild(this.element);
            this._containerToAdd = null;
        }
    }

    public resize(): void {

    }

    public get visible(): boolean {
        return !this.element.classList.contains("e5-hidden");
    }

    public set visible(value: boolean) {
        this.element.classList.toggle("e5-hidden", !value);
    }

    public dispose(): void {
        this.onResize.dispose();
        (this as Writable<BaseElement<any>>).element = null;
    }
}